"use client";

import React from "react";
import { MapPin, CircleCheck, Building2 } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from "@/components/ui/card";
const counties = ["Clay County", "Platte County", "Jackson County"];
const cities = ["Liberty", "North Kansas City", "Gladstone", "Kansas City"];
const mapPins = [{
  id: "pin-liberty",
  label: "Liberty",
  top: "28%",
  left: "68%"
}, {
  id: "pin-gladstone",
  label: "Gladstone",
  top: "38%",
  left: "52%"
}, {
  id: "pin-nkc",
  label: "North Kansas City",
  top: "52%",
  left: "49%"
}, {
  id: "pin-kc",
  label: "Downtown KC",
  top: "65%",
  left: "45%"
}];
export default function OurServiceArea() {
  return <section id="our-service-area" className="relative w-full min-h-[700px] flex items-center overflow-hidden bg-zinc-950">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1584719/img/kansas_city_dark_monochrome_map.png)] bg-cover bg-center opacity-60 mix-blend-luminosity" />
        {}
        <div className="absolute inset-0 bg-[linear-gradient(to_right,#ffffff0a_1px,transparent_1px),linear-gradient(to_bottom,#ffffff0a_1px,transparent_1px)] bg-[size:4rem_4rem]" />
        <div className="absolute inset-0 bg-gradient-to-r from-zinc-950/90 via-zinc-950/50 to-transparent" />
      </div>

      {}
      <div className="absolute inset-0 z-10 hidden md:block">
        <div className="relative w-full h-full max-w-7xl mx-auto">
          {mapPins.map((pin, i) => <div key={pin.id} data-index={i} className="absolute group cursor-pointer transform -translate-x-1/2 -translate-y-1/2" style={{
          top: pin.top,
          left: pin.left
        }}>
              <div className="relative flex items-center justify-center">
                <div className="absolute inset-0 bg-primary/30 rounded-full animate-ping" />
                <div className="relative bg-background border-2 border-primary rounded-full p-2.5 shadow-[0_0_15px_rgba(0,0,0,0.5)] transition-transform duration-300 group-hover:scale-110 group-hover:border-primary">
                  <Building2 className="size-5 text-primary" />
                </div>
              </div>
              <div className="absolute top-full left-1/2 -translate-x-1/2 mt-3 px-4 py-2 bg-foreground text-background text-sm font-bold rounded-md opacity-0 group-hover:opacity-100 transition-all duration-300 translate-y-2 group-hover:translate-y-0 whitespace-nowrap pointer-events-none shadow-xl z-20">
                {pin.label}
                <div className="absolute -top-1.5 left-1/2 -translate-x-1/2 border-4 border-transparent border-b-foreground" />
              </div>
            </div>)}
        </div>
      </div>

      {}
      <div className="container relative z-20 mx-auto px-4 md:px-6 py-12">
        <div className="max-w-md">
          <Card className="w-full shadow-2xl border-border/50 bg-background/95 backdrop-blur-xl">
            <CardHeader className="pb-4">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 text-primary text-xs font-bold tracking-wider uppercase w-fit mb-4">
                <MapPin className="size-3.5" />
                Local Expertise
              </div>
              <CardTitle className="text-3xl md:text-4xl font-bold tracking-tight text-foreground">
                Areas We Serve
              </CardTitle>
              <CardDescription className="text-base mt-2">
                Providing reliable, professional property management across the Kansas City metro area.
              </CardDescription>
            </CardHeader>
            
            <CardContent className="grid gap-6">
              <div className="space-y-3">
                <h4 className="font-semibold text-sm uppercase tracking-wider text-muted-foreground border-b border-border pb-2">
                  Primary Counties
                </h4>
                <ul className="grid grid-cols-1 gap-3">
                  {counties.map((county, i) => <li key={county} data-index={i} className="flex items-center gap-3 text-foreground font-medium">
                      <CircleCheck className="size-5 text-primary shrink-0" />
                      {county}
                    </li>)}
                </ul>
              </div>

              <div className="space-y-3">
                <h4 className="font-semibold text-sm uppercase tracking-wider text-muted-foreground border-b border-border pb-2">
                  Key Cities
                </h4>
                <div className="flex flex-wrap gap-2">
                  {cities.map((city, i) => <span key={city} data-index={i} className="inline-flex items-center px-3 py-1 rounded-md bg-muted text-muted-foreground text-sm font-medium">
                      {city}
                    </span>)}
                </div>
              </div>
            </CardContent>

            <CardFooter className="pt-2">
              <Button asChild size="lg" className="w-full text-base font-semibold h-12">
                <Link to="/ContactPage">Request a Consultation</Link>
              </Button>
            </CardFooter>
          </Card>
        </div>
      </div>
    </section>;
}